<!--
    almacena archivos en el store,
    en preafiliacion y dataUser
        props: ['op', 'rules', 'label']

        30/07/2023 props agregados props: ['index','btn']

        emit => correct
-->      
<template>
    <v-card flat class="rounded-0">
        <v-overlay v-model="overlay" :absolute="true">
            <v-btn color="warning" class="pa-6 elevation-0" @click="onClearFileInput">
                <v-icon class="mr-2">
                    mdi-file-document-edit-outline
                </v-icon>
                Actualizar archivos guardados
            </v-btn>
        </v-overlay>
        <v-card-title v-if="((this.limite == 2) || (this.op !== 'familiar'))">
            {{ label }}
        </v-card-title>
        <v-card-text>
            <v-alert border="left" class="rounded-0" colored-border dense color="orange" icon="mdi-alert" type="warning"
                elevation="6">
                <div>
                    <v-icon color="orange">mdi-circle-small</v-icon>
                    Archivo menor a
                    5MB
                </div>
                <div>
                    <v-icon color="orange">mdi-circle-small</v-icon>
                    Formatos permitidos
                    .jpg, .jpeg o .pdf
                </div>
            </v-alert>
            <v-col cols="12" md="2" v-for="(item, index) in files" :key="index">
                <v-card outlined width="150" height="100" class="d-flex flex align-center">
                    <v-btn fab absolute class="elevation-0 mt-5" @click="removeFile(index)" top right x-small>
                        <v-icon color="error">mdi-delete</v-icon>
                    </v-btn>
                    <v-card-subtitle>
                        <v-chip color="primary" class="text-caption mx-1 mt-5">
                            {{ (item.name.length > 10) ? item.name.substring(0, 10) + '....' : item.name }}
                        </v-chip>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" md="2" v-if="(this.files.length < limite)">
                <v-card class="d-flex justify-center elevation-5" width="150" height="100" @click="handleFileImport">

                    <v-card-actions>
                        <input ref="up" class="d-none" type="file" :accept="this.rules" @change="onFileChanged">
                        <v-icon x-large>mdi-plus</v-icon>
                    </v-card-actions>
                </v-card>
                <v-card-actions>
                    <v-chip color="primary lighten-1" text-color="white">
                        <v-icon class="mr-2">
                            {{ this.iconChip[this.files.length] }}
                            <!--
                                    mdi-card-account-details-outline
                                -->
                        </v-icon>
                        <div class="font-weight-bold text-caption">
                            {{ this.labelChip[this.files.length] }}
                        </div>
                    </v-chip>
                </v-card-actions>
            </v-col>
            <v-row>
                <v-col v-if="subtitle">
                    <v-alert type="warning" dense border="left" :icon="this.icon" color="orange">
                        {{ this.subtitle }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-btn elevation block :disabled="disabled" @click="guardar" class="pa-5" color="primary">
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>
                Guardar
            </v-btn>

        </v-card-text>

    </v-card>
</div></template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
    },
    mounted() {
        if (this.limite == 2) {
            this.labelChip = ['DNI FRONTAL', 'DNI DORSO']
            this.iconChip = ['mdi-card-account-details-outline', 'mdi-card-bulleted-outline']
        } else {
            this.labelChip = ['DOCUMENTACIÓN', 'DOCUMENTACIÓN', 'DOCUMENTACIÓN']
            this.iconChip = ['mdi-file-document-outline', 'mdi-file-document-outline', 'mdi-file-document-outline']
        }
    },
    data() {
        return {
            file: '',
            files: [],
            correct: false,
            fab: false,
            disabled: false,
            overlay: false,

            checkbox: false,

            labelChip: [],
            iconChip: []
        }
    },
    watch: {
        files() {
            this.filesVacio()
        },
        overlay() {
            return this.tieneFiles()
        },
    },
    computed: {
        ...mapGetters('preafiliacion', ['archivos']),
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('dataUser', ['labelTipoFamiliar']),

        fildNameCorto() {
            if (this.file.name.length > 10) {
                return this.file.name.substring(0, 10) + '...'
            } else {
                return this.file.name
            }
        },

    },
    methods: {

        //  modificacion archivos de preafiliacion 
        ...mapActions('preafiliacion', ['addFilesPre', 'deleteFilesPre', 'deleteItemPre']),

        // modificacion archivos de afiliado
        ...mapActions('dataUser', ['subirArchivos', 'addFiles', 'deleteFiles', 'deleteItem']),

        // correspondientes a las notificacioness
        ...mapActions('notificaciones', ['showSnack']),

        onClearFileInput() {
            this.overlay = false
            if (this.isAuthenticated) {
                this.addFiles({ file: '', op: this.op })
            } else {
                this.deleteFilesPre({ file: '', op: this.op })
            }
            //this.$emit('isCorrectForm', { valid: false, index: this.index, files: this.files, op: this.op })
        },
        removeFile(index) {
            //this.file = ''
            this.files.splice(index, 1)
            /*        if (this.isAuthenticated) {
                       this.files.splice(index, 1);
                       console.log(this.files)
                       this.deleteItem({ index: index, op: this.op })
       
                    } else {
                       this.deleteItemPre({ file: this.files.splice(index, 1), op: this.op })
                    } */
        },

        archivoPermitido(type) {
            // archivos permitidos (jpeg/jpg/png/docX/pdf/tiff/jfif)
            //,.jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document	
            //console.log("tipo Archivo -> " + archivo.type);
            //console.log("Archivo -> " + archivo.name);
            switch (type) {
                case "image/jpg":
                case "image/jpeg":
                case "application/pdf":
                    break;
                default:
                    return false
                /*                     msg = "Error: El tipo de Archivo NO está permitido!. Permitidos (jpeg/jpg/png/pdf)."; */
            }
            return true
        },
        filesVacio() {
            this.disabled = (this.files.length == 0)
        },
        tieneFiles() {
            this.overlay !== (this.archivos.length == 0)
        },

        guardar() {
            if (this.files.length !== 0) {
                if (this.op == 'familiar') {
                    this.addFiles({ file: this.files, op: this.op })
                }
                if (this.op == 'profesionales3') {
                    //
                    this.addFilesPre({ file: this.files, op: this.op })
                } else {
                    this.$emit('isCorrectForm', { valid: true, index: this.index, files: this.files, op: this.op })
                    setTimeout(() => {
                        this.overlay = true
                    }, 500)
                }
            } else {
                console.log('revisar archivos')
                this.showSnack({
                    type: '400',
                    message: 'No seleccionó ningun archivo.'
                })
            }
            /*             
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.$emit('isCorrectForm', { valid: true, index: this.index })
                } else {
        
                }
            }) */
        },

        handleFileImport() {
            // Trigger click on the FileInput
            try {
                this.$refs.up.click();
            } catch (error) {
                console.log(error)
                //Revisar
                //this.$('/Login').catch(() => { })
            }
        },

        onFileChanged(e) {
            if (e.target.files[0]) {
                /*Maximum allowed size in bytes
                  5MB Example
                 Change first operand(multiplier) for your needs*/
                const maxAllowedSize = 5 * 1024 * 1024;
                const permitido = this.archivoPermitido(e.target.files[0].type)
                if ((e.target.files[0].size < maxAllowedSize) && (permitido)) {
                    //,.jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document
                    this.file = e.target.files[0]
                    this.files.push(e.target.files[0])
                }
                else {
                    this.showSnack({
                        type: '400',
                        message: 'archivo no permitido. Debe ser menor a 5MB y en formato .pdf, .jpg, .jpeg o .png'
                    })
                    this.file = ''
                    this.files = []
                }

                //this.precargaFoto(this.selectedFile)

                //envio señal de fotoSeleccionada
                //this.$emit('haySeleccion')
                /*   const reader = new FileReader();
                  reader.onloadend = () => {
                      //referencia al elemento canvas
                      //let canvas = this.$refs.cv
                      //config
                      //const ctx = canvas.getContext("2d");
                      //nueva imagen
                      const img = new Image
                      img.src = URL.createObjectURL(this.selectedFile)
                      img.onload = function () {
                          console.log(canvas.width)
                          console.log(canvas.height)
                          console.log(img.naturalWidth)
                          console.log(img.naturalHeight)
                          var hRatio = canvas.width / img.naturalWidth
                          var vRatio = canvas.height / img.naturalHeight
                          var ratio = Math.min(hRatio, vRatio)
         
                          var centerX = (canvas.width - img.width * ratio) / 2
                          var centerY = (canvas.height - img.height * ratio) / 2
         
                          ctx.clearRect(0, 0, canvas.width, canvas.height)
         
                          //ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
                          ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
         
                      }
                      let dataURL = canvas.toDataURL('img/png');
                      const arr = dataURL.split(',');
                      console.log(dataURL)
                      this.addFotoCarnet(arr[1])
                  };
                  reader.readAsDataURL(this.selectedFile) */
            }
        },
    },
    props: ['op', 'rules', 'label', 'btn', 'index', 'subtitle', 'limite', 'icon']
}
</script>